import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
// @ts-ignore
import { VueAuthenticate } from "vue-authenticate";
import axios from "axios";

import { $authUrl } from "..";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

export const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
  baseUrl: $authUrl,
  tokenPath: "token"
});
